/**************
 Global
 ***************/

const root = "https://8r99xrl2z3.execute-api.us-east-1.amazonaws.com";
//const root = "http://localhost:3000";

// url search params
const urlParams = new URLSearchParams(window.location.search);

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    return fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//change an existing product in your cart
//let formData = { quantity: 1, id: 794864229 } or items: [{ quantity: 1, id: 794864229 }]
function changeCart(formData) {
    return fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//update cart note or attributes (_ for attributes are hidden and __ are private)
//let formData = { note: 'This is a note about my order', attributes: { 'Gift wrap': 'Yes' } }
//let formData = {updates: { 794864229: 2, 794864230: 3 }}
function updateCart(formData) {
    return fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

// download product
function downloadProduct(handle) {
    return fetch(`${Shopify.routes.root}products/${handle}.js`)
        .then(data => data.json());
}

// get cart
function getCart() {
    return fetch(`${Shopify.routes.root}cart.js`)
        .then(data => data.json());
}

// print price (515491 => $5,154.91)
function price(amountInCents, removeTrailingZeros = false) {
    // calculate total
    let total = (parseFloat(amountInCents) / 100).toFixed(2).toString();

    // add commas if needed
    total = total.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // remove trailing zeros
    if (removeTrailingZeros) {
        total = total.toString().replace(".00", "");
    }

    // return total
    return `${currency}${total}`;
}

// sleep
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

// artist's mailing address for the ash collection kit, one line per row
function kitAddress(artist) {
    let address = `${artist.address_name}\r\n${artist.address_street_1}\r\n`;
    if (artist.address_street_2) {
        address += `${artist.address_street_2}\r\n`;
    }
    address += `${artist.address_city}, ${artist.address_state} ${artist.address_zip}\r\n`;
    address += `${artist.address_country_code}`;
    return address;
}

/**************
 Design mode open mini cart
 ***************/
if (Shopify.designMode) {
    // if a user clicks on the mini cart
    document.addEventListener('shopify:section:select', function (event) {
        // open mini cart
        if (event.detail.sectionId === 'theme-mini-cart') {
            openCart();
        }

        // if they deselect the mini cart
        if (event.detail.sectionId !== 'theme-mini-cart') {
            closeCart();
        }
    });
}

// scroll to url hash
const maltertechParams = new URLSearchParams(window.location.search);

if (maltertechParams.get("scroll_to_class")) {
    const element = document.querySelector(`.${maltertechParams.get("scroll_to_class")}`);
    if (element) {
        window.scrollTo({
            behavior: 'smooth',
            top: element.offsetTop - 120,
        })
    }
}

if (maltertechParams.get("scroll_to_id")) {
    const element = document.querySelector(`#${maltertechParams.get("scroll_to_id")}`);
    if (element) {
        window.scrollTo({
            behavior: 'smooth',
            top: element.offsetTop - 120,
        })
    }
}


// function to calculate lighter color
function lightenColor(hex, amount = 20) {
    hex = hex.replace(/^#/, '');

    if (hex.length === 3) {
        hex = hex.split('').map(c => c + c).join('');
    }

    const num = parseInt(hex, 16);
    const r = Math.min(255, (num >> 16) + amount);
    const g = Math.min(255, ((num >> 8) & 0x00FF) + amount);
    const b = Math.min(255, (num & 0x0000FF) + amount);

    return `#${(1 << 24 | (r << 16) | (g << 8) | b).toString(16).slice(1)}`;
}

document.addEventListener('DOMContentLoaded', () => {
    const primary = getComputedStyle(document.documentElement)
        .getPropertyValue('--accent')
        .trim();

    if (primary.startsWith('#')) {
        const lighter = lightenColor(primary, 40); // adjust amount as needed
        document.documentElement.style.setProperty('--accent-light', lighter);
    }
});

// Function to send back in stock subscription to Klaviyo
async function sendKlaviyoBackInStockRequest(emailAddress, variantID) {
    await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${await klaviyo.account()}`, {
        method: 'POST',
        headers: {
            accept: 'application/vnd.api+json',
            revision: '2024-10-15',
            'content-type': 'application/vnd.api+json'
        },
        body: JSON.stringify({
            data: {
                type: "back-in-stock-subscription",
                attributes: {
                    channels: ["EMAIL"],
                    profile: {
                        data: {
                            type: "profile",
                            attributes: {
                                email: emailAddress,
                            }
                        }
                    }
                },
                relationships: {
                    variant: {
                        data: {
                            type: "catalog-variant",
                            id: `$shopify:::$default:::${variantID}`,
                        }
                    }
                }
            }
        })
    })
}